var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-container"},[_c('v-icon',{staticClass:"icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('h5',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }